import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import ContactChevalierForm from '../../components/ContactChevalierForm/ContactChevalierForm';
import { useContactUsRequest } from '../../hooks/useContactUsRequest';
import Field, { hasDataInFields } from '../PageBuilder/Field';
import SectionContainer from '../PageBuilder/SectionBuilder/SectionContainer';

import css from './ContactFormSection.module.css';

const ContactFormSection = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    options,
    currentUser,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasHeaderFields = hasDataInFields([title, description], fieldOptions);
  const { error, initialValues, inProgress, submitContactRequest, success } = useContactUsRequest({
    currentUser,
  });

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName || css.formSection}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
        </header>
      ) : null}

      <div className={css.introCopy}>
        <p className={css.introQuestion}>
          <FormattedMessage id="ContactPage.introQuestion" />
        </p>
        <p className={css.introBody}>
          <FormattedMessage
            id="ContactPage.introBody"
            values={{
              phoneLink: (
                <a className={css.phoneLink} href="tel:8592129423">
                  (859) 212-9423
                </a>
              ),
            }}
          />
        </p>
      </div>

      <div className={css.formCard}>
        {success ? (
          <p className={css.success}>
            <FormattedMessage id="ContactPage.submitSuccess" />
          </p>
        ) : (
          <ContactChevalierForm
            initialValues={initialValues}
            onSubmit={submitContactRequest}
            inProgress={inProgress}
            error={error}
            formIdPrefix="ContactUsForm"
            messagePlaceholderId="ContactPage.messagePlaceholder"
            submitErrorId="ContactPage.submitError"
          />
        )}
      </div>
    </SectionContainer>
  );
};

export default ContactFormSection;
